import {
	Button,
	FormControlLabel,
	ListItemSecondaryAction,
	Switch,
	TextField,
	Typography,
} from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { useFormik } from 'formik'
import React from 'react'

export type DenjiEventFields = {
	enabled: boolean
	soilTmpAbove: number | null // 土壌温度 >= でON
	soilHmdBelow: number | null // 土壌湿度 <= でON
}

type Props = {
	initialValues: DenjiEventFields
	disabled: boolean
	handleSubmit: (fields: DenjiEventFields) => void
}

// number 入力を number|null に正規化する (空文字 → null)
const toNullableNumber = (v: string): number | null => {
	if (v === '') return null
	const n = Number(v)
	return isNaN(n) ? null : n
}

// 電磁弁の1時間帯を編集。土中センサー(土壌温度/土壌湿度)の合成条件で ON 判定する。
const EditDenjiEventForm = (props: Props) => {
	const { disabled, initialValues } = props

	const { values, handleChange, handleSubmit, setFieldValue } =
		useFormik<DenjiEventFields>({
			initialValues,
			onSubmit: (fields) => {
				props.handleSubmit(fields)
			},
		})

	return (
		<div>
			<Typography variant="h6">時間帯の設定を編集</Typography>
			<FormControlLabel
				control={
					<Switch
						checked={values.enabled}
						onChange={(e) => handleChange(e)}
						name="enabled"
						color="primary"
					/>
				}
				label="有効にする"
			/>
			<List
				sx={{
					bgcolor: values.enabled ? undefined : 'action.disabledBackground',
				}}
			>
				<ListItem>
					<ListItemText
						primary="土壌温度 ≧ でON (℃)"
						secondary="空欄で土壌温度条件なし"
					/>
					<ListItemSecondaryAction style={{ width: '96px' }}>
						<TextField
							type="number"
							name="soilTmpAbove"
							value={values.soilTmpAbove ?? ''}
							disabled={disabled}
							placeholder="—"
							onChange={(e) =>
								setFieldValue('soilTmpAbove', toNullableNumber(e.target.value))
							}
							inputProps={{ step: 0.1, 'data-test': 'denji-event-soilTmp' }}
						/>
					</ListItemSecondaryAction>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="土壌湿度 ＜ でON (%)"
						secondary="空欄で土壌湿度条件なし"
					/>
					<ListItemSecondaryAction style={{ width: '96px' }}>
						<TextField
							type="number"
							name="soilHmdBelow"
							value={values.soilHmdBelow ?? ''}
							disabled={disabled}
							placeholder="—"
							onChange={(e) =>
								setFieldValue('soilHmdBelow', toNullableNumber(e.target.value))
							}
							inputProps={{
								step: 1,
								min: 0,
								max: 100,
								'data-test': 'denji-event-soilHmd',
							}}
						/>
					</ListItemSecondaryAction>
				</ListItem>
			</List>
			<div style={{ textAlign: 'right' }}>
				<Button onClick={() => handleSubmit()} color="primary" size={'large'}>
					変更する
				</Button>
			</div>
		</div>
	)
}

export default EditDenjiEventForm
